import PropTypes from 'prop-types';

const CARD_OFFER_SHAPE = {
  enabled: PropTypes.bool,
  heading: PropTypes.string,
  subHeading: PropTypes.string,
  body: PropTypes.string,
  ctaLabel: PropTypes.string,
  redirectUrl: PropTypes.string,
  imageUrl: PropTypes.string,
  imageLocationLabel: PropTypes.string,
  imageLabel: PropTypes.string,
  analyticElement: PropTypes.string,
  analyticDetail: PropTypes.string,
};

export default CARD_OFFER_SHAPE;
